import * as React from 'react'
import { SvgIcon, SvgIconProps } from './SvgIcon'

export type SvgIconType = ReturnType<typeof createSvgIcon>

export function createSvgIcon(
  path: React.ReactNode,
  displayName: string,
  additional?: { [key: string]: string }
) {
  function Component(
    props: Omit<SvgIconProps, 'children'>,
    ref: React.Ref<HTMLOrSVGElement>
  ) {
    const { style: _style1 = {}, ...other } = props
    const { style: _style2 = {}, ...other2 } = additional ?? {}

    return (
      <SvgIcon
        data-testid={`${displayName}Icon`}
        ref={ref}
        // @ts-ignore
        style={{ ..._style1, ..._style2 }}
        {...other2}
        {...other}
      >
        {path}
      </SvgIcon>
    )
  }

  return React.memo(React.forwardRef(Component))
}
